import { jsx as _jsx } from "react/jsx-runtime";
import { CatPrimaryNav } from '@blocks-react/components/PrimaryNav';
import { PAGE_BREAKPOINTS } from '../../../constants/commonConstants';
export const SubheaderPrimaryNav = ({ children, className, isCollapsed, moreDropdownLabel, style, mobileBreakPoint = PAGE_BREAKPOINTS.BLOCKS_LG }) => {
    return (_jsx(CatPrimaryNav, { behavior: "more", className: className, "data-testId": "subheader-primary-nav", isCollapsed: isCollapsed, moreDropdownLabel: moreDropdownLabel, style: style, mobileBreakPoint: mobileBreakPoint, children: children }));
};
